//#region src/utils/safe-get-pos.ts
var e = (e) => {
	try {
		return e();
	} catch {
		return;
	}
};
//#endregion
export { e as safeGetPos };
